import React, { ReactElement, useContext } from 'react';
import { FileCollectionT, ObjectContainerClientT, ObjectTypeClientT } from 'bovaljaren-models';
import FavoriteItem, { FavoriteItemActionsT } from './FavoriteItem/FavoriteItem';
import './FavoriteList.scss';
import { useObserver } from 'mobx-react-lite';
import { AppContext } from '../../../state/app.state';
import { Close } from '@material-ui/icons';
import { ObjectViewButtonFullwidth } from '../../views/ObjectView/Desktop/ObjectViewButtons/ObjectViewButtons';

type Props = {
    onObjectClick?: ((objectId: number) => void) | undefined;
    onClose?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
};

const FavoriteList: React.FC<Props> = ({ onObjectClick, onClose }): ReactElement => {

    const { state, favoriteState, presentationState } = useContext(AppContext);


    return useObserver(() => <>{ presentationState?.showFavoriteModal &&
        <div className='bv-favorite-list-wrapper'>
            <div className="bv-favorite-list">
                <div className={'bv-object-list-dropdown-btn'}>
                    <div className={'bv-object-list-expand-icon'}></div>
                    <div className={'bv-object-list-title'}>
                        Sparade
                    </div>
                    <div className={'bv-object-list-expand-icon'} onClick={(): void => presentationState.setShowFavoriteModal(false)}>
                        <Close/>
                    </div>
                </div>
                <div className="bv-favorite-list-items">
                    {state?.project?.objectTypes && state?.objects && state.objects.filter(o => favoriteState?.objectIds.find(id => o.id === id)).map((obj, index) =>
                        <FavoriteItem
                            typeName={state?.project?.objectTypes.find(oT => oT.id === obj.objectTypeId)?.name}
                            object={obj}
                            fileCollections={state?.fileCollections}
                            key={index}
                            onRemoveButtonClick={favoriteState?.removeFavorite}
                            onReadMoreClick={onObjectClick}
                        />
                    )}
                </div>
                {state?.project?.config?.shareObject && favoriteState?.objectIds && favoriteState?.objectIds.length > 0 &&
                    <ObjectViewButtonFullwidth label={'Dela alla sparade objekt'} onClick={(): void => {
                        state.setShareLink({ value: `https://${window.location.hostname}/bv/v3/project/${state.project?.id || ''}?favIt=${favoriteState?.objectIds?.join(',') || ''}` });
                        presentationState.setShowShareModal(true);
                    }}/>}
            </div>
        </div>
    }</>
    );
};

export default FavoriteList;